import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "color", "href", "onClick", "sx", "title", "underline", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
import React, { useContext } from 'react';
import { Link } from '@reach/router';
import { TAGTypography, Link as MuiLink } from '../../../';
import { AppContext } from '../../../contexts';

var LinkComponent = function LinkComponent(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      _ref$isExternalUrl = _ref.isExternalUrl,
      isExternalUrl = _ref$isExternalUrl === void 0 ? false : _ref$isExternalUrl,
      onClick = _ref.onClick,
      sx = _ref.sx,
      title = _ref.title,
      underline = _ref.underline;

  if (isExternalUrl) {
    return React.createElement(MuiLink, {
      className: className,
      href: href,
      underline: underline,
      title: title,
      sx: sx,
      onClick: onClick
    }, children);
  }

  return React.createElement(Link, {
    className: className,
    to: href,
    getProps: function getProps() {
      return {
        style: {
          textDecoration: 'none',
          color: 'inherit'
        }
      };
    },
    title: title,
    onClick: onClick
  }, children);
};

function getUrl(href, otherAppsPages) {
  var _pages$map, _globalThis$location, _globalThis$location2;

  var hrefPath = href.indexOf('?') !== -1 ? href.slice(0, href.indexOf('?')) : href;
  var isExternalUrl = href.startsWith('http') || href.startsWith('tel') || href === '#' || href.startsWith('mailto');

  if (isExternalUrl) {
    return {
      isExternalUrl: true,
      url: href
    };
  }

  var pages = otherAppsPages.pages;
  var pathExistsInOtherApps = pages === null || pages === void 0 ? void 0 : (_pages$map = pages.map(function (page) {
    return page.path;
  })) === null || _pages$map === void 0 ? void 0 : _pages$map.includes(hrefPath);
  return {
    isExternalUrl: pathExistsInOtherApps,
    url: pathExistsInOtherApps && (_globalThis$location = globalThis.location) !== null && _globalThis$location !== void 0 && _globalThis$location.origin ? "".concat((_globalThis$location2 = globalThis.location) === null || _globalThis$location2 === void 0 ? void 0 : _globalThis$location2.origin).concat(href) : href
  };
}

var TAGLink = function TAGLink(_ref2) {
  var children = _ref2.children,
      color = _ref2.color,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? '#' : _ref2$href,
      onClick = _ref2.onClick,
      sx = _ref2.sx,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title,
      _ref2$underline = _ref2.underline,
      underline = _ref2$underline === void 0 ? 'none' : _ref2$underline,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'bodyMediumBook' : _ref2$variant,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useContext = useContext(AppContext),
      appState = _useContext.state;

  var urlInfo = getUrl(href, appState);
  if (href.startsWith('tel:')) props.className = props.className ? "".concat(props.className, " InvocaNumber") : 'InvocaNumber';
  return React.createElement(LinkComponent, _objectSpread(_objectSpread({}, props), {}, {
    underline: underline,
    title: title,
    sx: sx,
    onClick: onClick,
    href: urlInfo.url,
    isExternalUrl: urlInfo.isExternalUrl
  }), React.createElement(TAGTypography, {
    variant: variant,
    color: color,
    sx: _objectSpread({
      textDecoration: underline === 'always' ? 'underline' : 'none',
      ':hover': {
        opacity: 0.8,
        textDecoration: underline === 'hover' && 'underline'
      }
    }, sx)
  }, children));
};

export default TAGLink;